export const baseURL = process.env.REACT_APP_BASE_URL;
export const env = process.env.REACT_APP_ENV;
export const ringCentralEmbeddableUrl = process.env.REACT_APP_RC_EMBEDDABLE_URL;
export const ringCentralServer = process.env.REACT_APP_RC_SERVER_URL;
